import { SurveyAnswerDto } from '../../types/survey';
import httpRequest from '../httpRequest';

const baseURL = process.env.REACT_APP_GW_API_URL;

const surveyApi = {
  isSurveyValid: async (id: string) => {
    const { status } = await httpRequest({
      baseURL: baseURL,
      url: `/surveys/${id}/valid`,
      method: 'GET',
    });

    return status;
  },

  submitSurvey: async ({ id, data }: { id: string; data: SurveyAnswerDto }) => {
    const { status } = await httpRequest({
      baseURL: baseURL,
      url: `/surveys/${id}`,
      method: 'PUT',
      data: data,
    });

    return status;
  },
};

export default surveyApi;
